module.exports = __webpack_public_path__ + "media/room_out.2982f3bf.wav";